import { MatDialogConfig } from '@angular/material/dialog';
import { CREATE_ORDER_PANEL_CLASS } from 'src/app/features/service-order/create-order/ui/create-order/create-order-dialog.config';
import { EditScheduledPaymentDateDialogData } from './dialog-edit-fecha-pago-programada.component';

/**
 * Builds Material Dialog configuration for editing scheduled payment date dialog.
 *
 * Description:
 *   Configures modal dialog dimensions, panel CSS class, autofocus, and payload for scheduled payment date editing.
 *
 * Parameters:
 *   dialogDataPayload: EditScheduledPaymentDateDialogData - Data containing the target service and order payload.
 *
 * Return Value:
 *   MatDialogConfig<EditScheduledPaymentDateDialogData> - Configured MatDialogConfig object.
 *
 * Exceptions & Errors:
 *   None.
 */
export function buildEditFechaPagoDialogConfig(
  dialogDataPayload: EditScheduledPaymentDateDialogData,
): MatDialogConfig<EditScheduledPaymentDateDialogData> {
  return {
    width: '420px',
    maxWidth: '94vw',
    panelClass: CREATE_ORDER_PANEL_CLASS,
    autoFocus: false,
    data: dialogDataPayload,
  };
}
